<p-dialog [(visible)]="exibeFiltros" [style]="{width: '900px'}" header="Filtros" [modal]="true" styleClass="p-fluid"
  (onHide)="hideDialog()">
  <ng-template pTemplate="content">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6">
        <label>Dealers:</label>
        <p-dropdown [showClear]="true" [options]="dealerOptions" [(ngModel)]="filtros.id_dealer" [filter]="true"
          placeholder="{{'Dealer'}}" appendTo="body" optionLabel="nome_dealer" optionValue="id_dealer">
        </p-dropdown>
      </div>
      <div class="p-field p-col-6">
        <label>Tipo Previsão:</label>
        <p-dropdown [showClear]="true" field="tipo" id="tipo" [options]="categoriaVendaOptions"
          [(ngModel)]="filtros.id_categoria_venda" placeholder="{{'Tipo Previsão'}}" optionLabel="nome_categoria_venda"
          optionValue="id_categoria_venda" [filter]="true" appendTo="body">
        </p-dropdown>
      </div>
      <div class="p-field p-col-6">
        <label>Ano:</label>
        <p-dropdown [showClear]="true" id="tipo" [options]="listaAnos" [(ngModel)]="filtros.anoNumber" placeholder="{{'Ano'}}"
          [filter]="true" [editable]="true" [virtualScroll]="true" appendTo="body" optionLabel="descricao" optionValue="ano">
        </p-dropdown>
      </div>
      <div class="p-field p-col-6">
        <label>Mês:</label>
        <p-calendar [(ngModel)]="filtros.mesDate" view="month" dateFormat="MM" placeholder="{{'Mês'}}" [readonlyInput]="true" appendTo="body" [showButtonBar]="true">
        </p-calendar>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton label="Limpar" icon="pi pi-trash" class="p-button-text" (click)="limpafiltros()"></button>
    <button pButton label="Filtrar" icon="pi pi-check" class="p-button-text" (click)="enviarFiltros()"></button>
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
  </ng-template>
</p-dialog>
